export default {"src":"/_next/static/media/edit.9f2948dc.svg","height":45,"width":45};